import PerformanceArtistsComponent from './PerformanceArtists.component'

export default PerformanceArtistsComponent